import { EMPTY_OBJECT } from '../../../../constants/common'
import { useAsyncCallback } from '../../../../hooks'
import {
  DOC_FLOW_SENDING_WIDGET_NEXT,
  DOC_FLOW_SENDING_WIDGET_PREVIOUS,
  DocFlowSendingWidgetProcessFieldName,
  isDocFlowSendingWidgetTypeResult,
} from '../../DocFlowSending'
import { useDocFlowContext } from '../useDocFlowContext'

export function useDocFlowSendingWidgets({
  activeWidget,
  onClickNext,
  onClickPrevious,
  onUpdateFileProcess,
}) {
  const { handleReloadDocFlow, phaseDisabled } = useDocFlowContext()

  const handleNextWidget = useAsyncCallback(
    (data = EMPTY_OBJECT) => {
      return onUpdateFileProcess({
        ...data,
        [DocFlowSendingWidgetProcessFieldName.SettingsFrom]: activeWidget,
        [DocFlowSendingWidgetProcessFieldName.SettingsTo]:
          DOC_FLOW_SENDING_WIDGET_NEXT[activeWidget],
      }).then(data => {
        if (
          isDocFlowSendingWidgetTypeResult(
            DOC_FLOW_SENDING_WIDGET_NEXT[activeWidget]
          )
        ) {
          handleReloadDocFlow()
        }

        return data
      })
    },
    [activeWidget, handleReloadDocFlow, onUpdateFileProcess]
  )

  const handlePreviousWidget = useAsyncCallback(
    (data = EMPTY_OBJECT) => {
      return onUpdateFileProcess({
        ...data,
        [DocFlowSendingWidgetProcessFieldName.SettingsFrom]: activeWidget,
        [DocFlowSendingWidgetProcessFieldName.SettingsTo]:
          DOC_FLOW_SENDING_WIDGET_PREVIOUS[activeWidget],
      }).then(data => {
        if (isDocFlowSendingWidgetTypeResult(activeWidget)) {
          handleReloadDocFlow()
        }

        return data
      })
    },
    [activeWidget, handleReloadDocFlow, onUpdateFileProcess]
  )

  return {
    handleNextWidget: phaseDisabled ? onClickNext : handleNextWidget,
    handlePreviousWidget: phaseDisabled
      ? onClickPrevious
      : handlePreviousWidget,
  }
}
